exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro-wrap{padding:20px 0;background-color:#e3e3e3}.intro-wrap .intro-content{background-color:#fff;padding:40px;margin-bottom:20px}.intro-wrap .intro-content li{padding-bottom:12px}.intro-wrap .intro-content li h3{font-size:16px;line-height:2;color:#333;background-color:#eee}.intro-wrap .intro-content li p{padding:6px}", ""]);

// exports
